import { render, staticRenderFns } from "./RegisterUserPage.vue?vue&type=template&id=03f5944a&"
import script from "./RegisterUserPage.vue?vue&type=script&lang=js&"
export * from "./RegisterUserPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUserPage.vue?vue&type=style&index=0&id=03f5944a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports